import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Block, VisuallyHidden } from '@mote/ui'
import { MotePlayerProviders, Scrubber } from '../../../shared/components'
import { useMotePlayer } from '../../../shared/contexts/motePlayer.context'
import { Controls } from '../Controls'

const MiniCardRoot = ({
  audioUrl,
  moteId,
  totalTime,
  scrubberPercentage,
  disabled,
  loading,
  onPlay,
  onPause,
  onEnd,
  dynamicWidth,
  isStandalone = true
}) => {
  const [currentTime, setCurrentTime] = useState(0)
  const [forcePause, setForcePause] = useState(false)

  const options = React.useMemo(() => {
    return {
      init: isStandalone,
      src: audioUrl,
      initialPercentagePosition: scrubberPercentage,
      isStandalone,
      playbackCallbacks: {
        onPlay,
        onPause,
        onEnd
      }
    }
  }, [audioUrl, scrubberPercentage, isStandalone, onPlay, onPause, onEnd])

  const { playerProps } = useMotePlayer(options)

  useEffect(() => {
    const currTime = +totalTime * (+scrubberPercentage / 100)
    setCurrentTime(currTime)
    if (+scrubberPercentage) setForcePause(true)
  }, [scrubberPercentage, totalTime])

  return (
    <Root
      data-mote-id={moteId}
      onClick={e => e.stopPropagation()}
      layout='horizontal'
      align='center'
      gap={10}
      dynamicWidth={dynamicWidth}
      {...playerProps}
    >
      <VisuallyHidden as='h2'>{playerProps['aria-label']}</VisuallyHidden>

      <Controls disabled={disabled} loading={loading} extraControlsList={[]} />

      <Scrubber
        variant='sm'
        loading={loading}
        currentTime={currentTime}
        totalTime={totalTime}
      />
    </Root>
  )
}

export const MiniCard = ({ autoFocus, ...rest }) => (
  <MotePlayerProviders
    moteId={rest.moteId}
    moteCreatedByUserId={rest.createdByUserId}
    autoFocus={autoFocus}
    isStandalone={rest.isStandalone}
  >
    <MiniCardRoot {...rest} />
  </MotePlayerProviders>
)

const Root = styled(Block)`
  background: #ffffff;
  border: 1px solid #e4e4e7;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 7px 9px;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  width: ${({ dynamicWidth }) => (dynamicWidth ? 'auto' : '146px')};
`
